<script>
import Card from "@/pages/components/card.vue";
import {useForm} from "@inertiajs/vue3";
import Changes from "@wielink-application/shared/js/mixins/changes";
import FormElements from "@wielink-application/shared/js/mixins/formElements";
import Username from "@/pages/components/form/horizontal/username.vue";

export default {
  mixins: [Changes, FormElements],
  components: {Card, Username},
  data() {
    return {
      form: useForm({
        active: 1,
        name: '',
        username: '',
        initials: '',
        lastname: '',
        email: '',
        color: '',
        roles: [],
        password: '',
        password_confirmation: '',
      })
    }
  },
  props: {
    user: {
      type: Object,
      required: false,
      default: {}
    },
    roles: {
      type: Object,
      default: {}
    },
  },
  methods: {
    setUser(user) {
      user.roles = user.roles.map((role) => role.id);
      this.form.defaults(Helpers.prepareFormDefaults(user));
      this.form.reset();
    },

    disable2Fac(event) {
      event.preventDefault();

      $.ajax({
        url: route('api.v1.users.disable2fac', {user: this.user.id}),
        method: 'PUT',
        success: (response) => {
          this.user.google2fa_secret = null;
          this.form.google2fa_secret = null;
        }
      })
    }
  },
}
</script>

<template>
  <div class="row g-4 pb-4">
    <div class="col-xl-6">
      <Card class="h-100">
        <h2 class="card-title">Gegevens</h2>
        <p>Voer hier de gegevens van de gebruiker in</p>

        <YesNo
            v-model="form.active"
            :form="form"
            name="active"
            label="Is de gebruiker actief?"
        />

        <Input
            v-model="form.initials"
            :form="form"
            name="initials"
            label="Voorletters"
            required
        />

        <Input
            v-model="form.lastname"
            :form="form"
            name="lastname"
            label="Achternaam"
            required
        />

        <Username
            v-model="form.username"
            :form="form"
            name="username"
            label="Gebruikersnaam"
            required
        />

        <Email
            v-model="form.email"
            :form="form"
            name="email"
            label="E-mail"
        />

        <Color
            v-model="form.color"
            :form="form"
            name="color"
            label="Kleur"
            required
        />

        <h3 class="card-title">Rollen</h3>

        <Checkbox
            v-for="role in roles"
            :key="role.id"
            v-model="form.roles"
            name="roles[]"
            :id="`role-${role.id}`"
            :form="form"
            :value="role.id"
            :label="role.name"
            :checked="form.roles.includes(role.id)"
        />
      </Card>
    </div>

    <div class="col-xl-6 d-flex flex-column gap-4">
      <Card class="flex-grow-1">
        <h2 class="card-title">Wachtwoord</h2>
        <p>Zorg voor een veilig wachtwoord</p>

        <Password
            v-model="form.password"
            :form="form"
            name="password"
            label="Wachtwoord"
            :required="form.password_confirmation != ''"
        />

        <Password
            groupClasses="mb-0"
            v-model="form.password_confirmation"
            :form="form"
            name="password_confirmation"
            label="Herhaal wachtwoord"
            :required="form.password != ''"
        />
      </Card>

      <Card v-if="user.google2fa_secret">
        <h2 class="card-title">Twee staps authenticatie (2FA)</h2>
        <p>Twee staps authenticatie (2FA) is ingeschakeld, druk op de onderstaande knop om dit uit te schakelen.</p>
        <button @click="disable2Fac" class="btn btn-danger">Uitschakelen</button>
      </Card>

    </div>
  </div>
</template>